<template>
  <AppIcon v-slot="attributes">
    <IHeroiconsTicket v-bind="attributes" :aria-label="t('ariaLabel')" />
  </AppIcon>
</template>

<script setup lang="ts">
const { t } = useI18n()
</script>

<i18n lang="yaml">
de:
  ariaLabel: Eintrittskarte
en:
  ariaLabel: Ticket
</i18n>
